import React from 'react';
import PropTypes from 'prop-types';
import { getTone, grey } from '../../../theme/tones';
import {
  Box,
  Card,
  Typography,
  Radio,
  RadioGroup,
  FormControlLabel,
  FormControl,
  TextField,
  Divider,
  Paper
} from '@material-ui/core';

const QuestionnairePreview = ({ questionnaire, questions }) => {
  if (!questionnaire) return null;

  return (
    <Box
      sx={{
        backgroundColor: 'action.hover',
        minHeight: '100%',
        py: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 2,
        fontFamily: '"Google Sans",Roboto,Arial,sans-serif'
      }}
    >
      {/* Header Card */}
      <Paper
        elevation={0}
        sx={{
          width: '100%',
          maxWidth: '770px',
          borderRadius: '8px',
          overflow: 'hidden',
          border: `1px solid ${grey(300)}`,
          position: 'relative'
        }}
      >
        <Box sx={{ height: '10px', backgroundColor: getTone('violet').base }} />
        <Box sx={{ p: 3 }}>
          <Typography variant="h4" sx={{ mb: 1, fontWeight: 400 }}>
            {questionnaire.name}
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.primary' }}>
            {questionnaire.type} - {questionnaire.formation_name || 'Formation Générale'}
          </Typography>
          {questionnaire.session_name && (
            <Typography variant="body2" sx={{ color: 'text.secondary', mt: 1 }}>
              Session N° {questionnaire.session_name}
            </Typography>
          )}
          <Divider sx={{ my: 2 }} />
          <Typography variant="body2" color="error">
            * Indique une question obligatoire
          </Typography>
        </Box>
      </Paper>

      {/* Dynamic Questions */}
      {questions.map((q, index) => (
        <Paper
          key={q.id || index}
          sx={{
            width: '100%',
            maxWidth: '770px',
            p: 3,
            borderRadius: '8px',
            border: `1px solid ${grey(300)}`,
            elevation: 0
          }}
          elevation={0}
        >
          <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 500 }}>
            {index + 1}) {q.text} <span style={{ color: getTone('rose').color }}>*</span>
          </Typography>

          {(() => {
            const options = typeof q.options === 'string' ? JSON.parse(q.options) : q.options;
            const isQCM = q.type === 'qcm' || q.type === 'mcq';
            
            if (isQCM) {
              return (
                <FormControl component="fieldset">
                  <RadioGroup>
                    {(options || []).map((opt, i) => {
                      const optText = typeof opt === 'object' ? (opt.text || '') : opt;
                      const optValue = typeof opt === 'object' ? (opt.text || '') : opt;
                      
                      return (
                        <FormControlLabel
                          key={i}
                          value={optValue}
                          control={<Radio size="small" />}
                          label={optText}
                          disabled
                          sx={{
                            '& .MuiTypography-root': {
                              fontSize: '14px',
                              color: 'text.primary'
                            }
                          }}
                        />
                      );
                    })}
                  </RadioGroup>
                </FormControl>
              );
            }
            
            return (
              <TextField
                fullWidth
                variant="standard"
                placeholder="Votre réponse"
                disabled
                multiline={q.type === 'open'}
                rows={q.type === 'open' ? 2 : 1}
              />
            );
          })()}
        </Paper>
      ))}

      {/* Footer / Submit Button Simulation */}
      <Box sx={{ width: '100%', maxWidth: '770px', py: 2 }}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
           <Typography variant="caption" sx={{ color: 'text.secondary' }}>
              Ne soumettez jamais de mots de passe via Google Forms.
           </Typography>
        </Box>
      </Box>
    </Box>
  );
};

QuestionnairePreview.propTypes = {
  questionnaire: PropTypes.object,
  questions: PropTypes.array
};

export default QuestionnairePreview;
